export default [
  // *===============================================---*
  // *--------- CLIENTS ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/clientes',
    name: 'clients',
    component: () => import('@/views/config/clients/ClientsList.vue'),
  },
]